import { Component } from '@angular/core';

@Component({
    selector: 'app',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.css']
})
export class MainComponent  {


}

